import { useState } from "react";
import { toast } from "sonner";
import { RefreshCw } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Field } from "@/components/erp";
import { SelectBox } from "@/components/Inputs";
import api, { errMsg } from "@/lib/api";

const TURLER = [{ value: "ForexSelling", label: "Döviz satış" }, { value: "ForexBuying", label: "Döviz alış" },
  { value: "BanknoteSelling", label: "Efektif satış" }, { value: "BanknoteBuying", label: "Efektif alış" }];

const Bilgi = ({ b }) => {
  if (!b) return <span>Henüz TCMB'den kur çekilmedi.</span>;
  const t = b.guncelleme ? new Date(b.guncelleme).toLocaleString("tr-TR") : "";
  return (
    <span>
      {b.kaynak === "manuel" ? `Bugün elle girildi (${b.guncelleyen || ""}, ${t}). Yarın TCMB'den otomatik güncellenir.`
        : `TCMB ${b.bulten || ""} bülteni · ${TURLER.find((x) => x.value === b.tur)?.label || ""} · ${t}`}
      {b.hata && <span className="block text-amber-300">{b.hata}</span>}
    </span>
  );
};

export const KurAyar = ({ f, set, setF }) => {
  const [busy, setBusy] = useState(false);
  const cek = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/kurlar/tcmb", { tur: f.kur_turu || "ForexSelling" });
      setF((s) => ({ ...s, kurlar: data.kurlar, kur_bilgi: data.kur_bilgi, kur_turu: data.kur_turu }));
      toast.success(`TCMB kurları alındı: USD ${data.kurlar.USD} · EUR ${data.kurlar.EUR}`);
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div className="space-y-3" data-testid="kur-ayar">
      <div className="grid sm:grid-cols-4 gap-4 items-end">
        {["USD", "EUR"].map((p) => (
          <Field key={p} label={`${p} kuru (TL)`}>
            <Input data-testid={`ayar-kur-${p}`} type="number" step="any" className="bg-white/5" value={f.kurlar?.[p] ?? ""}
              onChange={(e) => set("kurlar", { ...(f.kurlar || {}), [p]: Number(e.target.value) })} />
          </Field>
        ))}
        <Field label="TCMB kur türü"><SelectBox testid="ayar-kur-turu" value={f.kur_turu || "ForexSelling"} onChange={(v) => set("kur_turu", v)} options={TURLER} /></Field>
        <button type="button" data-testid="ayar-kur-tcmb" onClick={cek} disabled={busy} className="inline-flex items-center justify-center gap-1.5 h-10 px-4 rounded-full text-sm bg-white/10 hover:bg-white/15 disabled:opacity-50">
          <RefreshCw className={`w-4 h-4 ${busy ? "animate-spin" : ""}`} />TCMB'den şimdi çek</button>
      </div>
      <p className="text-xs text-muted-foreground" data-testid="ayar-kur-bilgi">Kurlar program açılışında Merkez Bankası'ndan otomatik çekilir (günün yeni bülteni 15:30'dan sonra alınır); elle değiştirip kaydederseniz o gün sizin değeriniz kullanılır. <Bilgi b={f.kur_bilgi} /></p>
    </div>
  );
};
